import styled from 'styled-components';
import { Layout } from 'antd';
import { COLORS } from '../../constants/colors';

const { Sider, Content } = Layout;

export const StyledLayout = styled(Layout)`
  min-height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  
  @media (max-width: 1024px) {
    display: flex;
    flex-direction: row;
    position: relative;
    width: 100vw;
    overflow-x: hidden;
  }
`;

export const StyledSider = styled(Sider)`
  background: white;
  box-shadow: 4px 0 12px rgba(0, 0, 0, 0.08);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 1001;
  overflow: hidden;
  height: 100vh;
  
  @media (max-width: 1024px) {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: auto;
    width: 100vw !important;
    min-width: 100vw !important;
    max-width: 100vw !important;
    z-index: 1002;
    transform: ${props => props.$mobileMenuOpen ? 'translateX(0)' : 'translateX(100%)'};
    transition: transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    will-change: transform;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    
    &.mobile-hidden {
      display: none !important;
    }
  }
  
  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
    background: white;
    overflow: hidden;
    height: 100vh;
  }
  
  .ant-layout-sider-trigger {
    display: none; /* Hide default trigger since we'll add our own */
  }
    .ant-menu {
    background: white;
    border-right: none;
    overflow-y: auto;
    overflow-x: hidden;
    flex: 1;
    
    /* Hide scrollbar but keep scrolling functionality */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
    }
    
    .ant-menu-item {
      background: white;
      margin: 6px 12px;
      border-radius: 8px;
      color: ${COLORS.textDark};
      font-weight: 500;
      font-size: 15px;
      height: 52px;
      line-height: 52px;
      padding: 0 16px;
      display: flex;
      align-items: center;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      transition: background 0.2s ease, color 0.2s ease;
      border: none;
        position: relative;
        
        /* divider handled with sibling selector to avoid curved ends on rounded corners */
      
      &:hover {
        background: ${COLORS.backgroundLight};
        color: ${COLORS.textDark};
        
        .ant-menu-item-icon {
          svg {
            color: ${COLORS.textDark} !important;
          }
        }
      }
      
      &.ant-menu-item-selected {
        background: ${COLORS.textDark};
        color: white;
        
        &::after {
          display: none;
        }
        
        .ant-menu-item-icon {
          color: white;
          
          svg {
            color: white !important;
            /* Fill the lucide outline icon when selected. lucide sets
               fill="none" as an SVG attribute on the <svg> and child
               paths inherit it, so we need !important on both the svg
               and its descendants to flip them to a filled glyph. */
            fill: currentColor !important;
            stroke-width: 1.5;
          }
          svg * {
            fill: currentColor !important;
          }
        }
      }
      
      .ant-menu-title-content {
  overflow: visible; /* allow divider to render in the gap without clipping */
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: inherit;
        flex: 1;
        min-width: 0;
        transition: none; /* Prevent color fade flash on selection */
      }
      
      /* Mobile styling - simple list with dividers */
      @media (max-width: 1024px) {
        margin: 0;
        border-radius: 0;
        height: 60px;
        padding: 0 20px;
        border: none;
        border-bottom: 1px solid ${COLORS.border};
        background: white;
        transform: none !important;
        box-shadow: none !important;
        font-size: 18px;
        font-weight: 500;
        /* hide desktop divider line on mobile */
        &::before { display: none; }
        
        &:hover {

    /* Draw a straight inset divider above every item except the first (desktop only) */
    .ant-menu-item + .ant-menu-item {
      position: relative;
    }
    .ant-menu-item + .ant-menu-item::before {
      content: '';
      position: absolute;
      left: 48px; /* align after icon + spacing */
      right: 16px;
      top: -3px; /* center within the 6px vertical gap */
      height: 1px;
      background: rgba(0, 0, 0, 0.08); /* subtle divider */
      opacity: 1;
      z-index: 1;
      pointer-events: none;
    }
    @media (max-width: 1024px) {
      .ant-menu-item + .ant-menu-item::before { display: none; }
    }
          background: ${COLORS.backgroundLight};
          transform: none !important;
          box-shadow: none !important;
          border-bottom: 1px solid ${COLORS.border};
        }
        
        &.ant-menu-item-selected {
          background: ${COLORS.backgroundLight};
          color: ${COLORS.textDark};
          transform: none !important;
          border-bottom: 1px solid ${COLORS.border};
          
          .ant-menu-item-icon {
            color: ${COLORS.textDark};
          }
        }
        
        &:last-child {
          border-bottom: none;
        }
      }
    }
      /* Collapsed menu styling */
    &.ant-menu-inline-collapsed {
      .ant-menu-item {
        margin: 6px auto;
        padding: 0 !important;
        width: 48px;
        height: 48px;
        line-height: 48px;
        justify-content: center;
        text-align: center;
        display: flex !important;
        align-items: center !important;
        
        &:hover {
          margin: 6px auto;
        }
        
        &.ant-menu-item-selected {
          margin: 6px auto;
        }
        
        .ant-menu-item-icon {
          margin-right: 0 !important;
          margin-left: 0 !important;
          flex-shrink: 0;
          
          svg {
            font-weight: 300 !important;
          }
        }
        
        .ant-menu-title-content {
          display: none;
        }
      }
      
      /* Collapsed submenu styling */
      .ant-menu-submenu {
        margin: 6px auto;
        
        > .ant-menu-submenu-title {
          margin: 0 auto;
          padding: 0 !important;
          width: 48px;
          height: 48px;
          line-height: 48px;
          justify-content: center;
          text-align: center;
          display: flex !important;
          align-items: center !important;
          
          .ant-menu-item-icon {
            margin-right: 0 !important;
            margin-left: 0 !important;
          }
          
          .ant-menu-title-content {
            display: none;
          }
          
          .ant-menu-submenu-arrow {
            display: none;
          }
        }
      }
    }
    
    .ant-menu-item-icon {
      color: inherit;
      font-size: 22px;
      margin-right: 14px;
      flex-shrink: 0;
      transition: color 0.2s ease;
      width: 22px;
      height: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      
      svg {
        color: inherit !important;
        width: 22px;
        height: 22px;
      }
    }
    
    /* Submenu (Analytics) styling */
    .ant-menu-submenu {
      margin: 0;
      padding: 0;
      
      > .ant-menu-submenu-title {
        border-radius: 8px;
        color: ${COLORS.textDark};
        font-weight: 500;
        font-size: 15px;
        height: 52px;
        line-height: 52px;
        padding: 0 16px !important;
        padding-left: 22px !important;
        margin: 6px 12px;
        display: flex;
        align-items: center;
        
        > .ant-menu-item-icon {
          color: ${COLORS.textDark};
          font-size: 22px;
          margin-right: 20px !important;
          margin-left: 0 !important;
          width: 22px;
          min-width: 22px;
          height: 22px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          
          svg {
            color: ${COLORS.textDark} !important;
            width: 22px;
            height: 22px;
          }
        }
        
        > .ant-menu-title-content {
          color: ${COLORS.textDark};
          flex: 1;
          margin-left: 0 !important;
        }
        
        /* Submenu arrow styling - position absolutely to not affect layout */
        .ant-menu-submenu-arrow {
          color: ${COLORS.textDark};
          right: 24px;
        }
        
        &:hover {
          background: ${COLORS.backgroundLight};
          color: ${COLORS.textDark};
          
          .ant-menu-item-icon svg {
            color: ${COLORS.textDark} !important;
          }
          
          .ant-menu-submenu-arrow {
            color: ${COLORS.textDark};
          }
        }
      }
      
      &.ant-menu-submenu-selected > .ant-menu-submenu-title,
      &.ant-menu-submenu-open > .ant-menu-submenu-title {
        color: ${COLORS.textDark};
        
        .ant-menu-item-icon svg {
          color: ${COLORS.textDark} !important;
        }
        
        .ant-menu-title-content {
          color: ${COLORS.textDark};
        }
        
        .ant-menu-submenu-arrow {
          color: ${COLORS.textDark};
        }
      }
    }
    
    /* Submenu dropdown - white background */
    .ant-menu-sub.ant-menu-inline {
      background: white !important;
      
      .ant-menu-item {
        color: ${COLORS.textLight};
        margin: 2px 0;
        margin-left: 36px;
        padding-left: 14px !important;
        
        .ant-menu-item-icon {
          color: ${COLORS.textLight};
          font-size: 20px;
          margin-right: 12px;
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          
          svg {
            color: ${COLORS.textLight} !important;
            width: 20px;
            height: 20px;
          }
        }
        
        &:hover {
          color: ${COLORS.textDark};
          
          .ant-menu-item-icon svg {
            color: ${COLORS.textDark} !important;
          }
        }
        
        &.ant-menu-item-selected {
          background: ${COLORS.textDark};
          color: white;
          
          .ant-menu-item-icon {
            color: white;
            
            svg {
              color: white !important;
              fill: currentColor !important;
              stroke-width: 1.5;
            }
            svg * {
              fill: currentColor !important;
            }
          }
        }
      }
    }

  }
`;

export const MobileOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1001;
  display: ${props => props.$visible ? 'block' : 'none'};
  
  @media (min-width: 1025px) {
    display: none;
  }
  
  @media (max-width: 1024px) {
    z-index: 1001;
  }
`;

export const Logo = styled.div`
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: ${props => props.collapsed ? 'center' : 'flex-start'};
  gap: 10px;
  padding: ${props => props.collapsed ? '12px 8px' : '12px 20px'};
  background: white;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  flex-shrink: 0;
  border-bottom: 1px solid #e8e8e8;

  .brand-heart {
    color: #1a1a1a;
    font-size: ${props => props.collapsed ? '26px' : '24px'};
    filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.08));
    transform-origin: center;
    animation: brandHeartBeat 2.4s ease-in-out infinite;
    transition: color 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  @keyframes brandHeartBeat {
    0%, 60%, 100% { transform: scale(1); }
    20% { transform: scale(1.15); }
    40% { transform: scale(1.05); }
  }

  .brand-text {
    font-family: 'Quicksand', 'Comfortaa', 'Segoe UI', sans-serif;
    font-weight: 700;
    font-size: 22px;
    color: #1a1a1a;
    letter-spacing: 0.2px;
    white-space: nowrap;
    line-height: 1;
  }

  img {
    height: 36px;
    width: auto;
    max-width: 36px;
    object-fit: contain;
    object-position: center;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));

    &:hover {
      transform: scale(1.03);
    }
  }

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const ControlButtonsWrapper = styled.div`
  display: flex;
  flex-direction: ${props => props.collapsed ? 'column' : 'row'};
  gap: ${props => props.collapsed ? '0' : '8px'};
  margin: ${props => props.collapsed ? '0' : '8px 12px 12px 12px'};
  flex-shrink: 0;
  
  @media (max-width: 1024px) {
    display: none;
  }
`;

export const CollapseButton = styled.button`
  background: transparent;
  padding: 12px 16px;
  cursor: pointer;
  transition: background 0.2s ease;
  flex-shrink: 0;
  border: none;
  margin: ${props => props.collapsed ? '8px 12px 12px 12px' : '0'};
  border-radius: 8px;
  flex: ${props => props.collapsed ? '0' : '1'};
  
  .collapse-button-inner {
    display: flex;
    align-items: center;
    justify-content: ${props => props.collapsed ? 'center' : 'flex-start'};
    gap: 10px;
    
    &:hover {
      .collapse-icon {
        color: ${COLORS.$mainRed};
      }
      
      .collapse-text {
        color: ${COLORS.$mainRed};
      }
    }
  }
  
  &:hover {
    background: ${COLORS.backgroundLight};
  }
  
  .collapse-icon {
    color: ${COLORS.textMedium};
    font-size: 16px;
    transition: color 0.2s ease;
    width: 18px;
    display: flex;
    justify-content: center;
  }
  
  .collapse-text {
    display: ${props => props.collapsed ? 'none' : 'block'};
    color: ${COLORS.textMedium};
    font-weight: 500;
    font-size: 14px;
    transition: all 0.3s ease;
  }
`;

export const StyledContent = styled(Content)`
  min-height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: linear-gradient(to bottom right, #f5f5f5 0%, #e8e8e8 50%, #dcdcdc 100%);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  @media (max-width: 1024px) {
    min-height: 100vh;
    max-height: 100vh;
    padding-left: 0 !important;
    width: 100vw;
    position: relative;
    padding-top: 60px; /* Match fixed top bar height (60px) */
    left: 0;
  }
`;

export const ContentScrollArea = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  /* Single source of page padding for all admin pages. PageContainer
     and similar wrappers should NOT add their own padding on top. */
  padding: 24px;

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.3);
  }

  /* Firefox scrollbar */
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;

  @media (max-width: 1024px) {
    padding: 16px;
    /* Leave room for the fixed bottom navigation bar (64px + safe area). */
    padding-bottom: calc(80px + env(safe-area-inset-bottom, 0));
  }
`;

export const MobileWrapper = styled.div`
  height: 100vh;
  overflow: hidden;
  
  @media (max-width: 1024px) {
    position: relative;
    overflow-x: hidden;
    width: 100vw;
    display: flex;
    flex-direction: column;
    height: 100vh;
  }
`;

export const ProfileButton = styled.div`
  background: white;
  border-top: 1px solid ${COLORS.border};
  padding: 10px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
  
  .profile-button-inner {
    background: ${COLORS.backgroundLight};
    border-radius: 12px;
    padding: 12px 16px;
    border: 1px solid ${COLORS.border};
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    
    &:hover {
      background: white;
      border-color: ${COLORS.$mainRed};
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      transform: translateY(-1px);
    }
  }
  
  .profile-content {
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: ${props => props.collapsed ? 'center' : 'space-between'};
    
    .left-section {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    
    .ant-avatar {
      width: 32px !important;
      height: 32px !important;
      border: 1px solid ${COLORS.border};
      transition: all 0.3s ease;
      
      &:hover {
        border-color: ${COLORS.$mainRed};
        transform: scale(1.03);
      }
    }
    
    .user-info {
      display: ${props => props.collapsed ? 'none' : 'flex'};
      flex-direction: column;
      gap: 2px;
      
      .user-name {
        font-weight: 600;
        color: ${COLORS.textDark};
        font-size: 14px;
        line-height: 1.2;
      }
      
      .user-role {
        font-size: 12px;
        color: ${COLORS.textMedium};
        line-height: 1.2;
      }
    }
    
    .caret {
      display: ${props => props.collapsed ? 'none' : 'block'};
      color: ${COLORS.textMedium};
      font-size: 12px;
      transition: transform 0.2s ease;
      margin-left: auto;
      margin-right: 8px;
    }
  }
`;

export const ProfilePopover = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  border: 1px solid ${COLORS.border};
  padding: 8px 0;
  min-width: 160px;
  
  .profile-menu-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    cursor: pointer;
    transition: all 0.2s ease;
    border: none;
    background: none;
    width: 100%;
    text-align: left;
    
    &:hover {
      background: ${COLORS.backgroundLight};
    }
    
    .anticon {
      color: ${COLORS.textMedium};
      font-size: 16px;
    }
    
    span {
      color: ${COLORS.textDark};
      font-weight: 500;
      font-size: 14px;
    }
    
    &.logout-item {
      border-top: 1px solid ${COLORS.border};
      margin-top: 4px;
      
      .anticon {
        color: ${COLORS.criticalRed};
      }
      
      span {
        color: ${COLORS.criticalRed};
      }
      
      &:hover {
        background: rgba(255, 77, 79, 0.1);
      }
    }
  }
`;

export const MobileTopBar = styled.div`
  display: none;
  
  @media (max-width: 1024px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 60px;
    background: white;
    border-bottom: 2px solid ${COLORS.border};
    padding: 0 16px;
    z-index: 1004;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const MobileTopBarTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
  color: ${COLORS.textDark};
  
  img {
    height: 35px;
    width: auto;
    max-width: 150px;
    object-fit: contain;
    object-position: center;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
  }
`;

export const MobileTopBarMenuButton = styled.button`
  background: transparent;
  border: none;
  font-size: 18px;
  color: black;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(0, 0, 0, 0.1);
    transform: scale(1.05);
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

export const MobileMenuContainer = styled.div`
  display: none;
  
  @media (max-width: 1024px) {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100vw;
    background: white;
    z-index: 1002;
    transform: ${props => props.$mobileMenuOpen ? 'translateX(0)' : 'translateX(100%)'};
    transition: transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    will-change: transform;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    overflow-y: auto;
    
    .ant-menu {
      background: white;
      border: none;
      padding-top: 60px;
      height: 100vh;
      
      .ant-menu-item {
        margin: 0;
        border-radius: 0;
        height: 60px;
        padding: 0 20px;
        border: none;
        border-bottom: 1px solid ${COLORS.border};
        background: white;
        font-size: 18px;
        font-weight: 500;
        display: flex;
        align-items: center;
        
        &:hover {
          background: ${COLORS.backgroundLight};
        }
        
        &.ant-menu-item-selected {
          background: ${COLORS.backgroundLight};
          color: ${COLORS.textDark};
          
          .ant-menu-item-icon {
            color: ${COLORS.textDark};
          }
        }
        
        &:last-child {
          border-bottom: none;
        }
        
        .ant-menu-item-icon {
          font-size: 22px;
          margin-right: 16px;
        }
      }
    }
  }
`;

// Styled Menu component to handle inline styles
export const menuStyles = {
  flex: 1,
  minHeight: 0,
  paddingTop: '8px',
  paddingBottom: '8px'
};

// Avatar style for profile button
export const avatarStyles = {
  backgroundColor: COLORS.$mainRed
};

// Mobile top bar actions wrapper
export const MobileTopBarActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

// ===== Mobile bottom navigation (tab bar + "More" sheet) =====

export const BottomNavBar = styled.nav`
  display: none;

  @media (max-width: 1024px) {
    display: flex;
    align-items: stretch;
    justify-content: space-around;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: 64px;
    padding-bottom: env(safe-area-inset-bottom, 0);
    background: ${COLORS.$white};
    border-top: 1px solid ${COLORS.border};
    box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.06);
    z-index: 1003;
  }
`;

export const BottomNavItem = styled.button`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 6px 0;
  color: ${props => (props.$active ? COLORS.textDark : COLORS.textMuted)};
  transition: color 0.2s ease;

  span {
    font-size: 11px;
    font-weight: ${props => (props.$active ? 600 : 500)};
    line-height: 1;
  }

  svg {
    ${props => (props.$active ? 'fill: currentColor;' : '')}
  }

  &:active {
    transform: scale(0.94);
  }
`;

export const MoreSheetOverlay = styled.div`
  display: none;

  @media (max-width: 1024px) {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    opacity: ${props => (props.$open ? 1 : 0)};
    visibility: ${props => (props.$open ? 'visible' : 'hidden')};
    transition: opacity 0.3s ease, visibility 0.3s ease;
    z-index: 1004;
  }
`;

export const MoreSheet = styled.div`
  display: none;

  @media (max-width: 1024px) {
    display: block;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    max-height: 80vh;
    overflow-y: auto;
    background: ${COLORS.$white};
    border-radius: 20px 20px 0 0;
    box-shadow: 0 -6px 24px rgba(0, 0, 0, 0.18);
    padding: 8px 0 calc(16px + env(safe-area-inset-bottom, 0));
    transform: ${props => (props.$open ? 'translateY(0)' : 'translateY(100%)')};
    transition: transform 0.32s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    z-index: 1005;
  }
`;

export const MoreSheetHandle = styled.button`
  display: block;
  width: 40px;
  height: 5px;
  border: none;
  border-radius: 3px;
  background: ${COLORS.border};
  margin: 8px auto 12px;
  cursor: pointer;
`;

export const MoreSheetList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MoreSheetItem = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border: none;
  background: ${props => (props.$active ? COLORS.backgroundLight : 'transparent')};
  cursor: pointer;
  padding: 14px 20px;
  color: ${COLORS.textDark};
  transition: background 0.15s ease;

  .left {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .label {
    font-size: 16px;
    font-weight: 500;
  }

  svg {
    color: ${COLORS.textLight};
  }

  &:hover {
    background: ${COLORS.backgroundLight};
  }
`;

export const MoreSheetSubList = styled.div`
  overflow: hidden;
  background: ${COLORS.backgroundLight};
  max-height: ${props => (props.$open ? '640px' : '0')};
  transition: max-height 0.3s ease;
`;

export const MoreSheetSubItem = styled.button`
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 12px 20px 12px 40px;
  color: ${props => (props.$active ? COLORS.textDark : COLORS.textLight)};

  .label {
    font-size: 15px;
    font-weight: ${props => (props.$active ? 600 : 500)};
  }

  &:hover {
    background: ${COLORS.border};
  }
`;
